import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import * as React from "react";
import { DetailsTabPanel } from "../../components/common/detailTabPanel/detailTabPanel";
import MyListScreen from "./groupReports/myListScreen";
import MyReportsScreen from "./groupReports/myReportsScreen";
import MyArchivedReportsScreen from "./groupReports/myArchivedReportsScreen";

export type GroupReportsProps = {
    tabIndex: string;
};

export const GroupReports: React.FC = (props) => {

    const [alignment, setAlignment] = React.useState<number>(0);


    const handleTabChange = (event: React.SyntheticEvent, newValue: number | null) => {
        if (newValue != null) setAlignment(newValue);
    };

    const tablist: [string, React.ReactNode][] = [
        ["My Lists", <MyListScreen/>],
        ["My Reports", <MyReportsScreen/>],
        ["My Archived Reports", <MyArchivedReportsScreen/>]
    ]

    return (
        <Box
            sx={{
                width: 1,
                height: 1,
                m: 2,
                borderWidth: 0,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box display={"flex"} justifyContent={"center"} sx={{ borderWidth: 0, flexGrow: 1 }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleTabChange}
                    sx={{ mb: 3 }}
                >
                    {tablist.map((tab, i) => (
                        <ToggleButton key={i} id={`group-reports-tab-${i}`} value={i}>
                            {tab[0]}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            {tablist.map((tab, i) => (
                <DetailsTabPanel
                    detailType={`${tab[0].toLowerCase().replace(" ", "-")}`}
                    key={tab[0]}
                    value={alignment}
                    index={i}
                >
                    {tab[1]}
                </DetailsTabPanel>
            ))}
        </Box>
    );
};

export default GroupReports;
